var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-link-manage',{ref:"table",staticClass:"pt-link-manage__withData",on:{"deleteLink":_vm.deleteLink}})}
var staticRenderFns = []

export { render, staticRenderFns }